import React from 'react';
import { connect } from 'react-redux';

import { Image } from './style';
import { IS_APP } from '../../services/target';

const Logo = props => !IS_APP && !!props.src && <Image {...props} />;

const mapStateToProps = state => ({
  src: state.sites.data.logo,
  alt: `Logo ${state.sites.data.name}`,
  title: state.sites.data.name
});

export default connect(mapStateToProps)(Logo);




// WEBPACK FOOTER //
// ./src/components/Logo/index.js